<div
  id="notification-panel"
  role="dialog"
  aria-label="Benachrichtigungen"
  class="fixed left-2 right-2 top-[4.5rem] md:absolute md:left-auto md:right-0 md:top-full md:mt-2 md:w-96 bg-base-100 rounded-lg shadow-2xl border border-base-300 z-[1001] max-h-[32rem] flex flex-col">

  <!-- Header -->
  <div class="flex items-center justify-between p-4 border-b border-base-300">
    <h3 class="font-semibold text-base-content flex items-center gap-2">
      <i class="fas fa-bell"></i>
      Benachrichtigungen
    </h3>

    <div class="flex items-center gap-1">
      @if (hasUnread) {
        <button
          (click)="markAllAsRead()"
          class="btn btn-ghost btn-xs"
          title="Alle als gelesen markieren">
          <i class="fas fa-check-double"></i>
          Alle gelesen
        </button>
      }
      <button
        (click)="openSettings()"
        class="btn btn-ghost btn-sm btn-circle"
        title="Benachrichtigungs-Einstellungen">
        <i class="fas fa-gear"></i>
      </button>
      <button
        (click)="closePanel.emit()"
        class="btn btn-ghost btn-sm btn-circle"
        title="Schließen">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  @if (loading && notifications.length === 0) {
    <div class="flex justify-center items-center py-12">
      <div class="loading loading-spinner loading-md text-primary"></div>
    </div>
  }

  <!-- Notifications List -->
  @if (notifications.length > 0) {
    <div class="overflow-y-auto flex-1">
      @for (notification of notifications; track notification.notificationId) {
        <div [ngClass]="{'group w-full flex items-start gap-3 p-4 hover:bg-base-200 transition-colors border-b border-base-300 last:border-b-0 cursor-pointer': true, 'bg-primary/5': !notification.read}" (click)="handleNotificationClick(notification)">

          <div [class]="'flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center bg-base-300 ' + getNotificationColor(notification.type)">
            <i [class]="getNotificationIcon(notification.type)"></i>
          </div>

          <div class="flex-1 min-w-0">
            <div class="font-semibold text-sm text-base-content mb-1 flex items-start justify-between gap-2">
              <span class="flex-1">{{ notification.title }}</span>
              @if (!notification.read) {
                <span class="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-1"></span>
              }
            </div>

            <!-- Source label badge -->
            @if (notification.metadata?.sourceType) {
              <div class="flex items-center gap-1 mb-1">
                @if (notification.metadata?.sourceType === 'buddy_group') {
                  <span class="badge badge-xs badge-accent gap-1">
                    <i class="fas fa-users text-[8px]"></i>
                    Buddy-Gruppe
                  </span>
                } @else if (notification.metadata?.sourceType === 'community_channel') {
                  <span class="badge badge-xs badge-secondary gap-1">
                    <i class="fas fa-hashtag text-[8px]"></i>
                    Community Kanal
                  </span>
                } @else if (notification.metadata?.sourceType === 'dm') {
                  <span class="badge badge-xs badge-ghost gap-1">
                    <i class="fas fa-envelope text-[8px]"></i>
                    Direktnachricht
                  </span>
                }
                @if (notification.metadata?.sourceName) {
                  <span class="text-xs text-base-content/50 truncate">{{ notification.metadata?.sourceName }}</span>
                }
              </div>
            }

            <p class="text-xs text-base-content/70 mb-1 line-clamp-2">
              {{ notification.message }}
            </p>

            <span class="text-xs text-base-content/50">
              {{ getFormattedTime(notification) }}
            </span>
          </div>

          <button
            (click)="dismissNotification($event, notification)"
            class="btn btn-ghost btn-xs btn-circle flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"
            title="Entfernen">
            <i class="fas fa-times"></i>
          </button>

        </div>
      }
    </div>
  }

  @if (!loading && notifications.length === 0) {
    <div class="flex flex-col items-center justify-center py-12 px-4 text-center">
      <i class="fas fa-bell-slash text-4xl text-base-content/30 mb-3"></i>
      <p class="text-sm text-base-content/70 mb-1">Keine Benachrichtigungen</p>
      <p class="text-xs text-base-content/50">Du bist auf dem neuesten Stand!</p>
    </div>
  }

</div>
